import {createReducer, on} from '@ngrx/store';
import {dialogWhereIsDatevClientIdStateInitial} from './dialog-where-is-datev-client-id.state.initial';
import {DialogWhereIsDatevClientIdActions} from './dialog-where-is-datev-client-id.actions';
import {DialogWhereIsDatevClientIdState} from './dialog-where-is-datev-client-id.state';


export const dialogWhereIsDatevClientIdReducers = createReducer(
  dialogWhereIsDatevClientIdStateInitial,

  on(
    DialogWhereIsDatevClientIdActions.open,
    (state): DialogWhereIsDatevClientIdState => ({
      ...state,
      isOpen: true,
    }),
  ),

  on(
    DialogWhereIsDatevClientIdActions.close,
    (state): DialogWhereIsDatevClientIdState => ({
      ...state,
      isOpen: false,
    }),
  ),
);
